module.exports = (Promise.resolve(__parcel__require__("./" + "Doppio.4a9f3a68.0621135d.js"))).then(() => parcelRequire('7SAbQ'));